import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/London");

function EndTimePopUp(props) {
  const {
    onCancel,
    onSubmit,
    assignedInspectorList,
    selectedSlot,
    onEndTimeChange,
    isReadOnly,
  } = props;

  const getEndTimeOptions = (inspector, selectedSlot) => {
    const selectedStart = dayjs.tz(selectedSlot.startTime, "Europe/London");
    const selectinspector = assignedInspectorList.filter(
      (x) => x.inspectorEmail === inspector,
    )[0];
    // const daySlot = selectinspector?.inspectorSlots.find((d) =>
    //   dayjs(d.date).isSame(dayjs(selectedSlot.date), "day")
    // );

    if (!selectinspector?.inspectorSlots) return [];

    return selectinspector.inspectorSlots
      .flatMap((day) =>
        day.slots.map((slot) => {
          const fullTime = dayjs.tz(slot.endTime, "Europe/London");
          //   console.log("ff", fullTime);
          return fullTime;
        }),
      )
      .filter((t) => {
        // console.log("Comparing:", t.format(), ">", selectedStart.format());
        return t.isAfter(selectedStart);
      })
      .map((t) => t.format("YYYY-MM-DDTHH:mm:ss")); // or "h:mm A" for display
  };

  console.log("end", selectedSlot);
  return (
    <>
      {!isReadOnly && (
        <div className="modal-overlay">
          <div className="endtime-modal-content" style={{ height: "auto" }}>
            <div className="modal-body p-3 d-flex flex-column gap-2">
              <span className="endtime-header">Select End Time</span>
              <span className="endtime-subheader pb-2">
                Please select an end time for the inspection.
              </span>
              {selectedSlot &&
                typeof selectedSlot === "object" &&
                Object.entries(selectedSlot)?.map(([email, slot]) => {
                  const startTimeFormatted = `${dayjs
                    .tz(slot.date, "Europe/London")
                    .format(
                      "ddd, MMM D",
                    )} - ${dayjs.tz(slot.startTime, "Europe/London").format("h:mm A")}`;
                  const selectedEndTime = slot.endTime || "";
                  const endTimeOptions = getEndTimeOptions(email, slot);
                  console.log("eee", endTimeOptions, selectedEndTime);
                  const isFullDayBooking = slot.isFullDay;
                  const startDateFormatted = `${dayjs
                    .tz(slot.date, "Europe/London")
                    .format("ddd, MMM D")}`;
                  return (
                    <div
                      key={email}
                      className="resident-card w-100 py-3 px-3 d-flex flex-column align-items-start"
                    >
                      <p className="endtime-label ">Inspector</p>
                      <p className="endtime-value mt-1 pb-2">
                        {slot.inspectorName}
                      </p>
                      {isFullDayBooking ? (
                        <>
                          <p className="endtime-label ">
                            Booking for entire day
                          </p>
                          <p className="endtime-value mt-1 pb-2">
                            {startDateFormatted}
                          </p>
                        </>
                      ) : (
                        <>
                          <p className="endtime-label ">Start Time</p>
                          <p className="endtime-value mt-1 pb-2">
                            {startTimeFormatted}
                          </p>
                          <p className="endtime-label">End Time</p>
                          <div className="d-flex flex-row flex-wrap gap-2 align-items-center">
                            <select
                              className="form-select mt-1"
                              style={{ width: "auto" }}
                              name="endTime"
                              id="endTime"
                              aria-label="Floating label select end time"
                              value={selectedEndTime}
                              onChange={(e) =>
                                onEndTimeChange(email, {
                                  ...slot,
                                  endTime: e.target.value,
                                })
                              }
                            >
                              {endTimeOptions?.map((type) => (
                                <option key={type} value={type}>
                                  {dayjs
                                    .tz(type, "Europe/London")
                                    .format("ddd, MMM D - h:mm A")}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              <div className="row mt-3 d-flex flex-row gap-2 px-4 align-items-center justify-content-center">
                <button
                  type="button"
                  style={{ width: "45%" }}
                  className="btn btn-secondary"
                  onClick={() => onCancel()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={{ width: "45%" }}
                  className="btn btn-primary"
                  onClick={() => onSubmit()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isReadOnly && (
        <div className="modal-overlay">
          <div className="endtime-modal-content" style={{ height: "auto" }}>
            <div className="modal-body p-3 d-flex flex-column gap-2">
              <span className="endtime-header">
                Confirm Inspection Schedule Dates
              </span>
              <span className="endtime-subheader pb-2">
                Please confirm to schedule the inspection dates as below.
              </span>
              {selectedSlot &&
                typeof selectedSlot === "object" &&
                Object.entries(selectedSlot)?.map(([email, slot]) => {
                  const startTimeFormatted = `${dayjs
                    .tz(slot.date, "Europe/London")
                    .format(
                      "ddd, MMM D",
                    )} - ${dayjs.tz(slot.startTime, "Europe/London").format("h:mm A")}`;
                  const selectedEndTime = slot.endTime || "";
                  const endTimeOptions = getEndTimeOptions(email, slot);
                  const isFullDayBooking = slot.isFullDay;
                  const startDateFormatted = `${dayjs
                    .tz(slot.date, "Europe/London")
                    .format("ddd, MMM D")}`;
                  console.log("eee", endTimeOptions, selectedEndTime);
                  return (
                    <div
                      key={email}
                      className="resident-card w-100 py-3 px-3 d-flex flex-column align-items-start"
                    >
                      <p className="endtime-label">Inspector</p>
                      <p className="endtime-value pb-2 mt-1">
                        {slot.inspectorName}
                      </p>
                      {isFullDayBooking ? (
                        <>
                          <p className="endtime-label ">
                            Booking for entire day
                          </p>
                          <p className="endtime-value mt-1 pb-2">
                            {startDateFormatted}
                          </p>
                        </>
                      ) : (
                        <>
                          <p className="endtime-label">Start Time</p>
                          <p className="endtime-value pb-2 mt-1">
                            {startTimeFormatted}
                          </p>
                          <p className="endtime-label">End Time</p>
                          <div className="d-flex flex-row flex-wrap gap-2 align-items-center">
                            {/* <p className="endtime-value ">{slot.inspectorName}</p> */}
                            <select
                              className="form-select"
                              style={{ width: "auto" }}
                              name="endTime"
                              id="endTime"
                              disabled
                              aria-label="Floating label select end time"
                              value={selectedEndTime}
                              onChange={(e) =>
                                onEndTimeChange(email, {
                                  ...slot,
                                  endTime: e.target.value,
                                })
                              }
                            >
                              {endTimeOptions?.map((option) => (
                                <option key={option} value={option}>
                                  {dayjs
                                    .tz(option, "Europe/London")
                                    .format("ddd, MMM D - h:mm A")}
                                </option>
                              ))}
                            </select>
                          </div>{" "}
                        </>
                      )}
                    </div>
                  );
                })}
              <div className="row mt-3 d-flex flex-row gap-2 px-4 align-items-center justify-content-center">
                <button
                  type="button"
                  style={{ width: "45%" }}
                  className="btn btn-secondary"
                  onClick={() => onCancel()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={{ width: "45%" }}
                  className="btn btn-primary"
                  onClick={(e) => onSubmit(e)}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EndTimePopUp;
